import React from "react"
import { createSvgIcon } from "@mui/material/utils"
import { BubbleChartRounded, PhishingRounded, ScienceRounded, ScubaDivingRounded } from "@mui/icons-material"

// MUI's own "fish" icon (SetMealRounded) is a fish *on a plate*, wrong context here and it looked
// it. A plain fish silhouette instead: one body shape (with a small punched-out eye) plus a tail fin,
// nothing more.
const FishRounded = createSvgIcon(
  <React.Fragment>
    <path
      fillRule="evenodd"
      d="M3 12C3 9 7 6.5 11.5 6.5C15.5 6.5 18.7 8.3 19.8 10.6L19.8 13.4C18.7 15.7 15.5 17.5 11.5 17.5C7 17.5 3 15 3 12ZM8.1 10.3A1.1 1.1 0 1 1 5.9 10.3A1.1 1.1 0 1 1 8.1 10.3Z"
    />
    <path d="M19.8 10.6 23 7.5 23 16.5 19.8 13.4Z" />
  </React.Fragment>,
  "FishRounded"
)

// Icon per specialist role, kept out of store/reducers/specialists.js since that's plain, serializable
// redux state and these are React components. The accent colors themselves live in the MUI theme
// (theme.palette.specialists[role]) so both the icon and its color can be looked up from just the role key.
export const SPECIALIST_ICONS = {
  diver: ScubaDivingRounded,
  fisher: PhishingRounded,
  aquarist: BubbleChartRounded,
  scientist: ScienceRounded,
  "aquarist-admin": FishRounded
}

export const getSpecialistIcon = (role) => SPECIALIST_ICONS[role] || ScubaDivingRounded

export const getSpecialistColor = (theme, role) => theme.palette.specialists?.[role] || theme.palette.primary
